import {
  NavMenuItemGroup,
} from "types/CMS/KontentAI/content-types/menu_item_group";
import { createResolver } from "../Factories/ResolverFactory";
import {

  NavMenuItem,
} from "types/CMS/KontentAI/content-types/menu_item";
import { navBar } from "types/CMS/Unum/Navbar/navbar";
import { menuArrayResolver } from "./menuItem";
import { productTaxonomyFilter } from "../Filters/productTaxomanyFilter";
import { roleTaxonomyFilter } from "../Filters/roleTaxomanyFilter";

export const primaryNavigationReslover = createResolver({
  resolve: (
    primaryNavigation: (NavMenuItemGroup | NavMenuItem)[],
    filters,
  ): navBar => {
    return {
      type: "navbar",
      items:
        menuArrayResolver
          .resolve(primaryNavigation, filters)
          .filter(
            (resolved) =>
              productTaxonomyFilter(resolved, filters?.usersProducts) &&
              roleTaxonomyFilter(resolved, filters?.usersRoles),
          ).result ?? [],
    };
  },
});
